import CommissionRateStatusUpdateItem from '../../../Domain/CommissionRateStatusUpdateItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import CommissionRateService from '../../../Services/CommissionRateService';

export default class ChangeCommissionStatusWindowDescription {
  static titleForEdit = 'Change Commission Rate Status';
  static itemType = CommissionRateStatusUpdateItem;
  static serviceFunction = CommissionRateService.ChangeStatus;

  getSelected() {}

  getSearchParameters() {}

  getAllItemInTheSearchAreSelected() {}

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'StatusId',
          label: 'New Status',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: ChangeCommissionStatusWindowDescription.getStatusValues,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
      ],
    },
  ];

  static getStatusValues(newEditedItem) {
    const array = [{ label: 'Choose one...', value: null }];
    switch (newEditedItem.OldStatusId) {
      case 1: {
        array.push({ label: 'Approved', value: 2 });
        array.push({ label: 'Declined', value: 3 });
        break;
      }
      case 2:
      case 3: {
        array.push({ label: 'Pending Approval', value: 1 });
        break;
      }
      default:
        return [];
    }
    return array;
  }
}
